<template>
  <div>
    <KTCodePreview v-bind:title="'In phiếu tiếp nhận bảo hành'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          @click="printData"
          style="width: max-content"
        >
          <i class="fas fa-print"></i> In phiếu
        </b-button>
      </template>
      <template v-slot:preview>
        <div id="printMe">
          <b-row
            style="display: block"
            class="mb-10"
          >
            <div class="text-center">
              <h5>PHIẾU TIẾP NHẬN BẢO HÀNH</h5>
            </div>
          </b-row>
          <b-row>
            <b-col md="8">
              <p><span class="custom-lable-text">Mã phiếu</span>: {{ reception.code || '—' }}</p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Cửa hàng</span>: {{ reception.storeName || '—' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Ngày tiếp nhận</span>:
                {{ reception.receptionDate || '—' }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Người kiểm tra</span>:
                {{ reception.inspectedByEmployeeName || '—' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Khách hàng</span>:
                {{ reception.customerName || '—' }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Ngày trả dự kiến</span>:
                {{ reception.expectedReturnDate || '—' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Số liên hệ</span>:
                {{ reception.contactNumber || reception.customerPhone || '—' }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Địa chỉ</span>:
                {{ reception.customerAddress || '—' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <p>
                <span class="custom-lable-text">Mô tả lỗi</span>:
                {{ reception.issueDescription }}
              </p>
            </b-col>
          </b-row>
          <b-table
            :items="productTableItems"
            :fields="productTableFields"
            bordered
            small
            class="mb-3"
          >
            <template #cell(stt)="row">
              {{ row.index + 1 }}
            </template>
            <template #cell(productName)="row">
              {{ row.item.productName || '—' }}
            </template>
            <template #cell(imeiCode)="row">
              {{ row.item.imeiCode || '—' }}
            </template>
            <template #cell(quantity)="row">
              {{ row.item.quantity || 1 }}
            </template>
          </b-table>
          <template v-if="(reception.lendingStockSlipDetails || []).length">
            <p class="mb-1 mt-5"><span class="custom-lable-text">Thông tin máy cho mượn</span></p>
            <b-table
              :items="reception.lendingStockSlipDetails || []"
              :fields="lendingTableFields"
              bordered
              small
              class="mb-3"
            >
              <template #cell(stt)="row">
                {{ row.index + 1 }}
              </template>
              <template #cell(stockSlipCode)="row">
                {{ row.item.stockSlipCode || '—' }}
              </template>
              <template #cell(productName)="row">
                {{ row.item.productName || '—' }}
              </template>
              <template #cell(productCode)="row">
                {{ row.item.productCode || '—' }}
              </template>
              <template #cell(quantity)="row">
                {{ row.item.quantity ?? '—' }}
              </template>
            </b-table>
          </template>
          <div class="signature-row">
            <b-row>
              <b-col>
                <p class="mb-0"><span class="custom-lable-text">Khách hàng</span></p>
                <p class="mb-0">(Ký, họ tên)</p>
              </b-col>
              <b-col>
                <p class="mb-0"><span class="custom-lable-text">Người lập phiếu</span></p>
                <p class="mb-0">(Ký, họ tên)</p>
              </b-col>
            </b-row>
          </div>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
import ApiService from '@/core/services/api.service'
import { printData } from '@/utils/common'
import { convertToDateSlash, DATE_FORMAT } from '@/utils/date'

export default {
  data() {
    return {
      reception: {
        code: '',
        storeName: '',
        receptionDate: '',
        statusName: '',
        customerName: '',
        statusChangeDate: '',
        contactNumber: '',
        customerPhone: '',
        customerAddress: '',
        productName: '',
        imeiCode: '',
        note: '',
        lendingStockSlipDetails: [],
      },
      productTableFields: [
        {
          key: 'stt',
          label: 'STT',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '60px' },
        },
        { key: 'productName', label: 'Sản phẩm' },
        { key: 'imeiCode', label: 'IMEI' },
        { key: 'quantity', label: 'SL', tdClass: 'text-right' },
      ],
      lendingTableFields: [
        {
          key: 'stt',
          label: 'STT',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '50px' },
        },
        { key: 'barCode', label: 'Mã vạch' },
        { key: 'productCode', label: 'Mã sản phẩm' },
        { key: 'productName', label: 'Tên sản phẩm' },
        { key: 'productImei', label: 'IMEI' },
        { key: 'quantity', label: 'SL', tdClass: 'text-right' },
      ],
    }
  },
  computed: {
    productTableItems() {
      const r = this.reception
      if (!r.productName && !r.imeiCode) return []
      return [{ productName: r.productName || '—', imeiCode: r.imeiCode || '—' }]
    },
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Tiếp nhận bảo hành', route: '/warranty-receptions' },
      { title: 'In phiếu tiếp nhận bảo hành' },
    ])
    this.loadReception()
  },
  methods: {
    printData() {
      printData()
    },
    loadReception() {
      const id = this.$route.query.id
      if (!id) return
      ApiService.get(`v1/warranties/receptions/${id}/print`)
        .then((res) => {
          const warrantyReception = res.data.data || {}
          this.reception = {
            ...warrantyReception,
            code: warrantyReception.code || warrantyReception.id,
            storeName: warrantyReception.storeName || '',
            receptionDate: convertToDateSlash(warrantyReception.createdAt, DATE_FORMAT),
            inspectedByEmployee: warrantyReception.inspectedByEmployee || '',
            expectedReturnDate: warrantyReception.expectedReturnDate
              ? convertToDateSlash(warrantyReception.expectedReturnDate, DATE_FORMAT)
              : '',
            issueDescription: warrantyReception.issueDescription || '',
            customerName: warrantyReception.customerName || '',
            contactNumber:
              warrantyReception.customerContactNumber ||
              warrantyReception.contactNumber ||
              warrantyReception.customerPhone ||
              '',
            customerPhone: warrantyReception.customerPhone || '',
            customerAddress: warrantyReception.customerAddress || '',
            productName: warrantyReception.productName || '',
            imeiCode: warrantyReception.imeiCode || '',
            lendingStockSlipDetails: warrantyReception.lendingStockSlipDetails || [],
          }
        })
        .catch(() => {
          this.reception = { ...this.reception }
        })
    },
  },
}
</script>

<style scoped>
.custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
}

.signature-row {
  margin-top: 3rem;
}
</style>
